export default __webpack_public_path__ + "static/media/warning.589785c5.svg";